import * as React from "react";

const TwitterIcon = (props) => (
	<svg id="a" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 450 450" {...props}>
		<defs>
			<style>{".p{fill:#a9d5d5}.t{fill:#b6dcdb}"}</style>
		</defs>
		<path d="M55.29 230.69c-2.45-2.36-3.77-5.53-5.88-8.14-.47-.48-.61-1.17-1.05-1.66-3.28-6.16-6.15-12.49-8.08-19.2-.96-3.32-2.13-6.68-2.37-10.08-.33-4.57-1.27-9.14-.77-13.76 0-.07.1-.13.25-.31 1.8.82 3.63 1.66 5.47 2.5.6.28 1.2.54 1.76.9l3.09 1.23c.91.36 1.86.6 2.74 1.02 2.76.61 5.39 1.66 8.28 1.96 1.37.14 2.85 1.19 4.41 1.35 3.11.33 6.21.96 9.36.54.78.29.93-.03.71-.72a87.13 87.13 0 0 1-18.11-17.66c-5.4-7.08-9.67-14.82-12.53-23.23-1.25-3.67-2.45-7.39-3.18-11.29-.61-3.24-1.14-6.52-1.41-9.77-.23-2.7-.2-5.5-.13-8.26.04-1.49.57-3.04-.39-4.46-.09-.13-.07-.36-.03-.53 1.32-5.18 1.41-10.6 3-15.73 2.06-6.66 4.54-13.16 7.84-19.33.85-1.6 1.03-1.62 2.26-.23 5.18 5.9 10.22 11.92 15.87 17.38 6.67 6.45 13.53 12.67 20.86 18.38 5.21 4.06 10.52 7.97 16 11.64 3.17 2.12 6.48 4.04 9.73 6.05.59.28 1.16.6 1.65 1.04 7.21 4.29 14.64 8.18 22.29 11.59 5.46 2.43 10.89 5.03 16.71 6.66 2.37.67 4.67 1.75 7.02 2.61 1.78.65 3.63.93 5.41 1.54 5.73 1.96 11.58 3.61 17.5 4.78 5.69 1.13 11.4 2.26 17.16 3.13 4.86.73 9.77.93 14.61 1.76.43.07.83.21 1.3 0 1.31-.59 2.6-.5 3.86.21.3.17.68.19 1.03.26 2.88.55 3.03.48 2.37-2.38-1.7-7.35-1.43-14.8-1.27-22.24.16-7.77 2-15.16 4.57-22.48 1.79-5.1 3.95-9.97 6.64-14.6 3.05-5.25 6.68-10.08 10.77-14.59 3.25-3.59 6.79-6.84 10.53-9.86 3.18-2.57 6.56-4.93 10.24-6.77 3.5-1.75 6.66-4.24 10.63-5 .67-.47 1.56-.49 2.21-1.03 3.08-1.08 6.12-2.26 9.36-2.87 3.45-.64 6.87-1.47 10.38-1.8.71-.07 1.4-.13 2.1-.37 1.64-.56 3.38-.68 5.03-.29 1.54.37 3.03.25 4.51.02 1.62-.26 3.2-.17 4.79.12 2.77.51 5.54 1.1 8.34 1.44 3.16.39 6.2 1.09 9.15 2.29 1.64.66 3.41.99 5.13 1.47.57.32 1.08.73 1.71.94 4.82 1.5 9.05 4.19 13.42 6.6.51.41 1.2.54 1.67 1.03 5.28 3.53 10.19 7.5 14.61 12.06.67.69 1.22 1.2 2.29.59.66-.38 1.53-.44 2.32-.54 4.07-.53 7.96-1.69 11.86-2.92 3.47-1.1 6.92-2.29 10.43-3.27 2.08-.58 3.94-1.68 5.95-2.42 2.75-1.01 5.5-2.07 8.09-3.49.55-.36 1.2-.55 1.71-.98 3.75-1.46 7.17-3.55 10.64-5.55.39-.22.74-.52 1.42-.23-.26 2.71-1.71 5.1-2.75 7.56-1.66 3.93-3.7 7.71-6.01 11.31-2.99 4.66-6.35 9.03-10.21 13.01-2.85 2.95-5.81 5.79-9.03 8.35-1.68 1.33-3.45 2.55-5.17 3.81-.67.31-1.05.98-1.68 1.33-.36.04.1.53 0 .19-.03-.1.23-.23.42-.26.47-.09.88.04 1.26.32 4.55-.16 9.01-1.21 13.34-2.31 6.79-1.73 13.72-3.13 20.22-5.98 2.85-1.25 5.92-2.03 8.75-3.39.47-.23 1.12-.52 1.44.06.25.46-.09.98-.41 1.46-2.38 3.55-4.95 6.97-7.68 10.25-4.38 5.27-8.88 10.44-13.87 15.17-2.83 2.68-5.75 5.26-8.7 7.81-3.04 2.62-6.27 5.01-9.34 7.59-.69.58-1.13 1.05-1.05 1.97.18 2.13.03 4.26.46 6.41.39 1.9.44 4.02.03 5.9-.8 3.64-.02 7.37-.97 10.96 1.05 2.57-.3 5.06-.32 7.6-.02 2.55-.44 5.14-.86 7.7-.38 2.34-.6 4.76-.98 7.12-1.13 6.95-2.53 13.85-4.14 20.7-1.73 7.32-3.96 14.5-6.37 21.6-2.21 6.5-4.72 12.92-7.44 19.23-2.61 6.05-5.39 12.06-8.6 17.82-3.57 6.39-7.19 12.74-11.16 18.91-5.02 7.8-10.52 15.24-16.36 22.42-4.55 5.6-9.4 10.95-14.51 16.08-3.64 3.65-7.31 7.29-11.17 10.69-4.61 4.06-9.28 8.08-14.29 11.67-1.66 1.19-3.23 2.52-4.84 3.78-.25.4-.75.3-1.08.55-.21.39-.78.23-.98.64-4.53 2.95-9.01 5.99-13.65 8.79-6.18 3.73-12.5 7.11-19.02 10.16-.87.41-1.67.96-2.5 1.45-.82.58-1.84.65-2.7 1.13-3.68 1.55-7.29 3.28-11.05 4.61-5.39 1.92-10.77 3.88-16.3 5.45-4.3 1.22-8.59 2.88-12.92 3.63-5.17.89-10.19 2.55-15.47 2.99-1.61.13-3.38.65-5.06.91-1.74.27-3.65.25-5.29.64-2.52.6-5.07.17-7.51.79-3.23.82-6.56.61-9.82 1.07-1.86.26-3.7.41-5.62.09-1.47-.25-3.04.14-4.56.15-4.13.03-8.27.08-12.4-.03-2.42-.06-4.87.2-7.23 0-3.62-.29-7.28-.34-10.9-1.1-1.87-.39-3.96-1.1-5.99-.31-.23.09-.54.05-.79-.01-5.98-1.57-12.18-1.97-18.19-3.39-6.97-1.65-13.95-3.18-20.77-5.43-3.81-1.26-7.74-2.19-11.49-3.63-5.91-2.27-11.89-4.39-17.6-7.15-.9-.43-1.8-.81-2.78-.97-.52-.42-1.18-.62-1.71-1.01-.28-.34-.8-.21-1.07-.57-2.39-1.16-4.84-2.23-7.17-3.51-5.44-3.01-10.83-6.11-16.24-9.19-.38-.22-.77-.47-1.06-.79-.15-.16-.21-.54-.12-.74.08-.17.48-.39.62-.33 2.12.89 4.41-.72 6.54.48.57.32 1.4.2 2.12.2 6.11.02 12.23.3 18.31-.09 3.2-.21 6.56.31 9.66-1.03.89-.39 1.75.25 2.64.1 4.29-.71 8.62-1.23 12.86-2.16 4.3-.95 8.62-1.86 12.87-2.99 4.1-1.09 8.09-2.62 12.12-4 8.21-2.8 16.07-6.46 23.62-10.67 7.29-4.08 14.42-8.49 20.95-13.77-.69-1.5-2.19-1.09-3.37-1.37-1.02-.24-2.14.23-3.16-.27-1.33-.63-2.78-.62-4.19-.81-6.98-.95-13.53-3.25-19.95-6.06a88.263 88.263 0 0 1-11.49-6.1c-.48-.44-1.12-.65-1.56-1.14-5.26-3.28-9.82-7.39-14.12-11.82-2.36-2.43-4.64-4.93-6.64-7.66-4.87-6.66-9.01-13.71-11.63-21.58-.23-.7-.61-1.28-.93-1.91-.25-.49-1.16-.88-.56-1.57.38-.44.98-.13 1.51 0 1.73.4 3.55.3 5.24.58 4.22.7 8.43.16 12.62.42 3.24.2 6.39-.62 9.59-.7 2.44-.67 4.9-1.26 7.29-2.09.25 0 .5 0 .74.06-.66-.2-1.36.02-2.02-.18-.22-.11-.43-.24-.62-.4-5.4-1.26-10.4-3.63-15.56-5.55-.51-.41-1.19-.56-1.67-1.03-4.23-1.98-8-4.73-11.96-7.15-1.93-1.18-3.49-2.95-5.23-4.44-.74-.64-1.51-1.25-2.26-1.87-.7-.36-1.15-.99-1.69-1.53l-6.4-7.12c-.45-.47-.67-1.11-1.12-1.58Z" />
		<path
			d="M137.89 321.91c1.67-.15 3.35-.37 4.98.3.61.25 1.18.22 1.78-.08.36-.18.94-.33 1.12.23.21.64-.32.93-.83 1.13-.16.06-.35.05-.52.07-1.5-.8-3.07-1.26-4.79-1.19-.62.03-1.26.09-1.74-.45Z"
			style={{
				fill: "#a4d3d0",
			}}
		/>
		<path
			d="M103.38 262c-2.56.36-4.95 1.57-7.59 1.56.04-.52.35-.55.82-.71 1.56-.52 3.52-.16 4.57-1.9.18-.02.37-.03.55-.05.34.69 1.8-.32 1.65 1.1Z"
			style={{
				fill: "#e4f2f2",
			}}
		/>
		<path
			d="M389.98 111.38c-.91.21-1.82.41-2.86.65q1.19-1.59 2.86-2.23c-.25.53-.42 1.05 0 1.58Z"
			style={{
				fill: "#9acecf",
			}}
		/>
		<path
			d="M73.23 186.31c.31.17.63.33.94.51.31.18.69.4.5.81-.23.51-.74.47-1.13.25-.38-.21-.68-.56-1.02-.85.24-.24.48-.48.71-.72Z"
			style={{
				fill: "#b3dad9",
			}}
		/>
		<path
			d="M278.24 63.91c-.41 1.05-1.26 1.13-2.21 1.03.48-.89 1.28-1.09 2.21-1.03Z"
			style={{
				fill: "#66b6b6",
			}}
		/>
		<path
			d="M50.46 183.18c-1.08.12-1.99-.24-2.74-1.02 1.14-.26 2 .2 2.74 1.02Z"
			style={{
				fill: "#83c3c2",
			}}
		/>
		<path
			d="M251.22 375.31c.76-.7 1.63-1.16 2.7-1.13-.65.96-1.6 1.23-2.7 1.13Z"
			style={{
				fill: "#c8e4e4",
			}}
		/>
		<path
			d="M353.84 72.5c-.78.01-1.42-.19-1.67-1.03.76.01 1.56-.03 1.67 1.03Z"
			style={{
				fill: "#7abfbf",
			}}
		/>
		<path
			d="M48.37 220.89c.96.17 1.04.89 1.05 1.66-.74-.31-1.14-.83-1.05-1.66Z"
			style={{
				fill: "#99cdcd",
			}}
		/>
		<path
			d="M83.95 254.38c.74.05 1.48.1 1.67 1.03-.86.16-1.45-.14-1.67-1.03Z"
			style={{
				fill: "#90cac9",
			}}
		/>
		<path className="t" d="M47.75 372.63c.78-.02 1.51.05 1.71 1.01-.84.13-1.42-.21-1.71-1.01Z" />
		<path
			d="M44.62 180.93c-.8.12-1.4-.16-1.76-.9.78-.08 1.56-.16 1.76.9Z"
			style={{
				fill: "#66b5b4",
			}}
		/>
		<path
			d="M62.81 239.39c.79.26 1.34.78 1.69 1.53-1.02 0-1.58-.52-1.69-1.53Z"
			style={{
				fill: "#a1d2d2",
			}}
		/>
		<path
			d="M411.09 71.53c-.2.97-.93 1.01-1.71.98.31-.79.88-1.1 1.71-.98Z"
			style={{
				fill: "#93cbca",
			}}
		/>
		<path
			d="M338.75 64.87c-.85.19-1.41-.14-1.71-.94.78-.07 1.35.25 1.71.94Z"
			style={{
				fill: "#8ac7c8",
			}}
		/>
		<path
			d="M55.29 230.69c.76.25 1.13.78 1.12 1.58-.63-.35-1.17-.75-1.12-1.58Z"
			style={{
				fill: "#6eb9b9",
			}}
		/>
		<path
			d="M100.7 307.81c.78.02 1.36.32 1.56 1.14-.82.02-1.28-.44-1.56-1.14Z"
			style={{
				fill: "#7ec1c0",
			}}
		/>
		<path
			d="M114.65 130.32c-.76-.01-1.34-.31-1.65-1.04.86-.15 1.4.23 1.65 1.04Z"
			style={{
				fill: "#95cccc",
			}}
		/>
		<path className="p" d="M290.07 353.14c.22-.45.63-.55 1.08-.55-.16.58-.55.69-1.08.55Z" />
		<path className="t" d="M46.68 372.06c.48-.04.87.09 1.07.57-.5.08-.87-.08-1.07-.57Z" />
		<path className="p" d="M289.09 353.78c.17-.45.47-.7.98-.64-.16.47-.5.66-.98.64Z" />
		<path
			d="M103.38 262c-.19-.91-1.33-.39-1.65-1.1.68 0 1.36-.05 2.03.04.36.05.94.24.75.77-.17.47-.72.29-1.13.29Z"
			style={{
				fill: "#5cb2b1",
			}}
		/>
	</svg>
);

export default TwitterIcon;
